import LegalPage from '../../components/LegalPage';
import CardNB from '../../components/ui-nb/CardNB';

export default function PrivacyPage() {
  const today = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <LegalPage
      title="Política de Privacidad"
      lastUpdated={`Última actualización: ${today}`}
    >
      <CardNB>
        <div className="space-y-8">
          <p className="text-lg text-nb-text-secondary">
            Tellow Up! ("nosotros", "nuestro", o "nos") está comprometido con proteger tu privacidad. Esta política explica cómo recopilamos, usamos y protegemos tu información.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Responsable del Tratamiento</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! es responsable de tus datos personales. Si tienes preguntas, contáctanos en privacy@tellowup.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Datos que Recopilamos</h2>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Datos de identidad: nombre, correo electrónico, información de Google OAuth</li>
              <li>Datos de organización: nombre del taller, código de taller, estado de suscripción</li>
              <li>Datos de seguimiento: códigos de liberación, estado de reparación, marcas de tiempo</li>
              <li>Datos de uso: registros de acceso, información del dispositivo, dirección IP</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Finalidad y Base Legal</h2>
            <p className="mb-3 text-nb-text-secondary">
              Procesamos tus datos para: (a) proporcionar y mantener el servicio; (b) notificarte sobre cambios; (c) proporcionar soporte al cliente; (d) detectar y prevenir fraude. Base legal: consentimiento para datos de identidad, interés legítimo para análisis de uso.
            </p>
            <p className="font-medium text-nb-text-secondary">Base Legal:</p>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Prestar el servicio SaaS</li>
              <li>Mejorar nuestra plataforma</li>
              <li>Enviar notificaciones relacionadas con el servicio</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Compartición de Datos</h2>
            <p className="text-nb-text-secondary">
              No vendemos tus datos. Compartimos datos con: (a) Supabase (nuestro proveedor de backend, datos almacenados en EE.UU.); (b) Google (autenticación OAuth). Todos los proveedores están obligados por acuerdos de procesamiento de datos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Datos de Pago</h2>
            <p className="text-nb-text-secondary">
              El procesamiento de pagos es manejado por Stripe. No almacenamos los datos completos de tu tarjeta de crédito. Stripe puede recopilar y procesar datos de pago según su política de privacidad. Solo recibimos confirmación del estado del pago.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Transferencias Internacionales</h2>
            <p className="text-nb-text-secondary">
              Los datos pueden ser transferidos y procesados en Estados Unidos. Para usuarios de la UE, aseguramos garantías adecuadas según el RGPD.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Retención de Datos</h2>
            <p className="text-nb-text-secondary">
              Retenemos tus datos mientras tu cuenta esté activa y por 12 meses después de la eliminación. Los registros financieros se retienen por 7 años según requisitos legales.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Registros Financieros</h2>
            <p className="text-nb-text-secondary">
              Conservamos registros financieros por 7 años según requisitos legales para propósitos fiscales y de cumplimiento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Tus Derechos</h2>
            <p className="mb-3 text-nb-text-secondary">
              Tienes derecho a: acceder, rectificar, borrar, restringir el procesamiento, objetar el procesamiento y portar tus datos. Contacta privacy@tellowup.com para ejercer tus derechos.
            </p>
            <ul className="list-disc pl-5 space-y-1 text-nb-text-secondary">
              <li>Acceder a tus datos</li>
              <li>Corregir datos inexactos</li>
              <li>Solicitar eliminación</li>
              <li>Portabilidad de datos</li>
              <li>Retirar consentimiento en cualquier momento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cookies</h2>
            <p className="text-nb-text-secondary">
              No usamos cookies propias. Google OAuth puede usar cookies según su política de privacidad. No rastreamos usuarios entre sitios web.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Privacidad de Menores</h2>
            <p className="text-nb-text-secondary">
              Nuestro servicio no está dirigido a usuarios menores de 16 años. No recopilamos intencionalmente datos de niños. Si descubrimos tal recopilación, eliminaremos los datos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Cambios a Esta Política</h2>
            <p className="text-nb-text-secondary">
              Te notificaremos de cambios por email o aviso en el sitio web. El uso continuo después de cambios constituye aceptación.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Contacto</h2>
            <p className="text-nb-text-secondary">
              Para preocupaciones de privacidad, contacta a nuestro Oficial de Protección de Datos en privacy@tellowup.com.
            </p>
          </section>
        </div>
      </CardNB>
    </LegalPage>
  );
}
